import React, { useMemo, useState } from "react";
import GalleryItemShimmer from "./item.shimmer";
import styles from "./gallery.module.css";
import GalleryItem from "./item";
import classNames from "classnames";
import { useAddToCartButton } from "../../Pregrine/CartPage/useAddToCartButton";
import DEFAULT_OPERATIONS from "../../Pregrine/PinCode/PinCode.gql";
import PinCodeCheck from "../../components/PinCodeCheck/PinCodeCheck";
import { useToasts } from "react-toast-notifications";
import { useLazyQuery } from "@apollo/client";

const Gallery = (props) => {
  const { items, categoryNames } = props;
  const [selectedItem, setSelectedItem] = useState("");
  const [openPinCodeModal, setOpenPinCodeModal] = useState(false);
  const [buyNow, setBuyNow] = useState(false);
  const { addToast } = useToasts();
  const { checkPinCodeQuery } = DEFAULT_OPERATIONS;

  const cartButtonProps = useAddToCartButton({
    item: selectedItem,
    buyNow,
    categoryNames: categoryNames,
  });

  const handlePinCodeModal = () => {
    setOpenPinCodeModal(!openPinCodeModal);
  };

  const { handleAddToCart } = cartButtonProps;
  const [checkPinCode] = useLazyQuery(checkPinCodeQuery, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data?.pin_code?.status === "1") {
        handleAddToCart();
      } else {
        addToast(
          "Delivery not available to this location. Please check for other options.",
          {
            appearance: "warning",
            autoDismiss: true,
            style: {
              backgroundColor: "#745600",
              color: "#fff",
            },
          }
        );
      }
    },
  });

  const handleCart = (sku) => {
    const pincode = localStorage.getItem("PinCode");
    if (pincode) {
      checkPinCode({
        variables: {
          pinCode: pincode,
          sku,
          state: Math.random(),
        },
      });
    } else {
      setOpenPinCodeModal(!openPinCodeModal);
    }
  };

  const pinCodeCheckFun = (availableFlag) => {
    if (availableFlag) {
      handleAddToCart();
      setOpenPinCodeModal(false);
    }
  };

  const galleryItems = useMemo(
    () =>
      items.map((item, index) => {
        if (item === null) {
          return <GalleryItemShimmer key={index} />;
        }
        return (
          <GalleryItem
            key={item.id}
            item={item}
            handleCart={handleCart}
            setSelectedItem={setSelectedItem}
            buyNow={buyNow}
            setBuyNow={setBuyNow}
          />
        );
      }),
    [items]
  );

  return (
    <>
      <div
        className={classNames("row row-grid", styles.margn)}
        aria-live="polite"
        aria-busy="false"
      >
        <div className={styles.items}>{galleryItems}</div>
      </div>
      <PinCodeCheck
        openPinCodeModal={openPinCodeModal}
        pinCodeCheckFun={pinCodeCheckFun}
        handlePinCodeModal={handlePinCodeModal}
        product={selectedItem}
      />
    </>
  );
};

export default Gallery;
